/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner';

/**
 * 
 * @export
 * @interface CreateScreenerLeadTag201Response
 */
export interface CreateScreenerLeadTag201Response {
    /**
     * 
     */
    data?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner;
}

/**
 * Check if a given object implements the CreateScreenerLeadTag201Response interface.
 */
export function instanceOfCreateScreenerLeadTag201Response(value: object): value is CreateScreenerLeadTag201Response {
    return true;
}

export function CreateScreenerLeadTag201ResponseFromJSON(json: any): CreateScreenerLeadTag201Response {
    return CreateScreenerLeadTag201ResponseFromJSONTyped(json, false);
}

export function CreateScreenerLeadTag201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateScreenerLeadTag201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerFromJSON(json['data']),
    };
}

export function CreateScreenerLeadTag201ResponseToJSON(json: any): CreateScreenerLeadTag201Response {
    return CreateScreenerLeadTag201ResponseToJSONTyped(json, false);
}

export function CreateScreenerLeadTag201ResponseToJSONTyped(value?: CreateScreenerLeadTag201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerToJSON(value['data']),
    };
}

